import {getAppSetting} from "../config/AppSettings";
import {Configuration, PodVisitsApi} from "./generated-src";

export default function() {
    const appSetting = getAppSetting('apiUrl');
    const apiBasePath = `https://${appSetting}/jwt`;
    return new PodVisitsApi(new Configuration({basePath: apiBasePath}));
}
